import { Flex, FlexProps } from '@radix-ui/themes';
import { cn } from '@/lib/utils';
import { Box, type BoxProps } from './Box';
import { type RadixColors } from './RadixProps';

type DecorativeBoxProps = BoxProps & {
  color?: string;
  radius?: string;
};

export function DecorativeBox({ className, color, radius, style, ...props }: DecorativeBoxProps) {
  return (
    <Box
      className={cn(className)}
      style={{
        ...(color && { backgroundColor: `var(--color-${color})` }),
        ...(radius && { borderRadius: `var(--radius-${radius})` }),
        ...style,
      }}
      {...props}
    />
  );
}

export type { DecorativeBoxProps };

type QuoteBoxProps = FlexProps & {
  /** Stronger accent fill; use for content quoted on the viewer's side. */
  strong?: boolean;
  color?: RadixColors;
};

/** Quoted-context box: accent left border over a translucent accent fill. */
export function QuoteBox({ strong, color, className, style, ...props }: QuoteBoxProps) {
  return (
    <Flex
      p="2"
      minWidth="0"
      data-accent-color={color}
      className={cn(className)}
      style={{
        borderRadius: 'var(--radius-btn)',
        backgroundColor: strong ? 'var(--accent-a4)' : 'var(--accent-a2)',
        border: '1px solid var(--accent-a4)',
        borderLeft: '2px solid var(--accent-9)',
        opacity: 0.85,
        ...style,
      }}
      {...props}
    />
  );
}

export type { QuoteBoxProps };
